export default __webpack_public_path__ + "static/media/error.b3c96ee6.mp3";